/** Manufacturer codes from Excel sheet "Coduri furnizori". */
export const MANUFACTURER_CODES = [
    { name: 'Sistema', code: '00' },
    { name: 'Presblock', code: '01' },
    { name: 'Poliplast', code: '02' },
    { name: 'Pipex', code: '03' },
    { name: 'Hy pipe', code: '04' },
    { name: 'Romfilms', code: '05' },
    { name: 'Tia', code: '06' },
    { name: 'Luxor', code: '07' },
    { name: 'Goodwee', code: '08' },
    { name: 'BRM Technical', code: '09' },
    { name: 'Isofom', code: '10' },
    { name: 'Ecotech', code: '11' },
    { name: 'Manta', code: '12' },
    { name: 'Powerack', code: '13' },
    { name: 'Sipla', code: '14' },
    { name: 'Prima Plus', code: '15' },
    { name: 'Engo', code: '16' },
    { name: 'Watts', code: '17' },
    { name: 'Eberle', code: '18' },
    { name: 'Errecom', code: '19' },
    { name: 'Dalap', code: '20' },
    { name: 'Delta Aluminiu', code: '21' },
    { name: 'R.Bi Esse', code: '22' },
    { name: 'Ingotools', code: '23' },
    { name: 'Panel Radiant', code: '24' },
    { name: 'Afriso', code: '25' },
    { name: 'Itap', code: '26' },
    { name: 'Valvex', code: '27' },
    { name: 'Tongwei', code: '28' },
    { name: 'Fome', code: '29' },
    { name: 'Temad', code: '30' },
    { name: 'Poltergeist', code: '31' },
    { name: 'Heatpex', code: '32' },
    { name: 'Tap Home', code: '33' },
    { name: 'Osmap', code: '34' },
    { name: 'Mvt', code: '35' },
    { name: 'Grundfos', code: '36' },
    { name: 'Isoclima', code: '37' },
    { name: 'Jurgen Schlosser', code: '38' },
    { name: 'Barberi', code: '39' },
    { name: 'EV connect', code: '40' },
    { name: 'Rexpol', code: '41' },
    { name: 'Adeplast', code: '42' },
    { name: 'Askoll', code: '43' },
    { name: 'Trotus', code: '44' },
    { name: 'Ac-fix', code: '45' },
    { name: 'Aqua Tech', code: '46' },
    { name: 'Hrale', code: '47' },
    { name: 'Bal Bos', code: '48' },
    { name: 'Ntm', code: '49' },
    { name: 'Aerauliqa', code: '50' },
    { name: 'Hirsch', code: '51' },
    { name: 'Intervest', code: '52' },
    { name: 'Electroinstal', code: '53' },
    { name: 'Davide', code: '54' },
    { name: 'General Box', code: '55' },
    { name: 'Rinaldi', code: '56' },
    { name: 'Termo Plus', code: '57' },
    { name: 'Tecnovielle', code: '58' },
    { name: 'Indecal', code: '59' },
    { name: 'Ergovent', code: '60' },
    { name: 'Nordtex', code: '61' },
    { name: 'Aertecnica', code: '62' },
    { name: 'MC2F', code: '63' },
    { name: 'Torn HVAC', code: '64' },
    { name: 'Gewiss', code: '65' },
    { name: 'Julien', code: '66' },
    { name: 'Wurth', code: '67' },
    { name: 'Galmet', code: '68' },
    { name: 'Tesy', code: '69' },
    { name: 'Jonix', code: '70' },
    { name: 'Thermal Technology', code: '71' },
    { name: 'Enetec', code: '72' },
    { name: 'Effebi', code: '73' },
    { name: 'Forch', code: '74' },
    { name: 'Fitt Air', code: '75' },
    { name: 'Selena', code: '76' },
    { name: 'Bandatech', code: '77' },
    { name: 'Sildor', code: '78' },
    { name: 'Kubitech', code: '79' },
    { name: 'Markus', code: '80' },
    { name: 'Diplo Connect', code: '81' },
    { name: 'Aerfor', code: '82' },
    { name: 'Thesslagreen', code: '83' },
    { name: 'Blansol', code: '84' },
    { name: 'Domusa', code: '85' },
    { name: 'Moes', code: '86' },
    { name: 'Longi', code: '87' },
    { name: 'K2', code: '88' },
    { name: 'Solax', code: '89' },
    { name: 'Energy 3000 Solar', code: '90' },
    { name: 'Ground Therm', code: '91' },
    { name: 'Huawei', code: '92' },
    { name: 'THX', code: '93' },
    { name: 'Maxa', code: '94' },
    { name: 'Heliroma', code: '95' },
    { name: 'Fotonia', code: '96' },
    { name: 'Aerocompact', code: '97' },
    { name: 'Turbo energy', code: '98' },
    { name: 'Tracon', code: '99' },
    { name: 'Hitech', code: '100' },
    { name: 'Sungrow', code: '101' },
    { name: 'Izopick', code: '102' },
    { name: 'Dasolar', code: '103' },
    { name: 'Ariston', code: '104' },
    { name: 'Felicity', code: '105' },
];

export const CURRENCY_OPTIONS = [
    { title: 'RON', value: 'ron' },
    { title: 'PLN', value: 'pln' },
    { title: 'EUR', value: 'euro' },
    { title: 'USD', value: 'usd' },
];

export { SYSTEM_OPTIONS } from '@/data/productCategories';

/** @type {Array<{ id?: number|null, name: string, code: string }>|null} */
let runtimeManufacturerCodes = null;

/**
 * @param {unknown} row
 * @returns {{ id?: number|null, name: string, code: string }|null}
 */
function normalizeManufacturer(row) {
    if (!row) {
        return null;
    }
    const normalized = {
        id: row?.id ?? null,
        code: String(row?.code ?? '').trim(),
        name: String(row?.name ?? '').trim(),
    };
    if (!normalized.code && !normalized.name) {
        return null;
    }
    return normalized;
}

/**
 * @returns {Array<{ id?: number|null, name: string, code: string }>}
 */
export function getManufacturerCodes() {
    return runtimeManufacturerCodes || MANUFACTURER_CODES;
}

/**
 * @param {Array<{ id?: number|null, name: string, code: string }>|null} manufacturers
 */
export function setManufacturerCodes(manufacturers) {
    if (!Array.isArray(manufacturers) || !manufacturers.length) {
        runtimeManufacturerCodes = null;
        return;
    }
    runtimeManufacturerCodes = manufacturers
        .map(normalizeManufacturer)
        .filter(Boolean)
        .sort((a, b) => String(a.code).localeCompare(String(b.code), undefined, { numeric: true }));
}

/**
 * @param {unknown} row
 * @returns {{ id?: number|null, name: string, code: string }|null}
 */
export function upsertManufacturer(row) {
    const normalized = normalizeManufacturer(row);
    if (!normalized) {
        return null;
    }
    const current = [...getManufacturerCodes()];
    const existingIndex = current.findIndex((item) => (
        (normalized.id != null && item.id === normalized.id)
        || (normalized.code && item.code === normalized.code)
    ));
    if (existingIndex >= 0) {
        current.splice(existingIndex, 1, {
            ...current[existingIndex],
            ...normalized,
        });
    } else {
        current.push(normalized);
    }
    current.sort((a, b) => String(a.code).localeCompare(String(b.code), undefined, { numeric: true }));
    runtimeManufacturerCodes = current;
    return { ...normalized };
}